import { render, staticRenderFns } from "./MoveToFixedConfirmationPopup.vue?vue&type=template&id=5a074a7c&scoped=true"
import script from "./MoveToFixedConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./MoveToFixedConfirmationPopup.vue?vue&type=script&lang=js"
import style0 from "./MoveToFixedConfirmationPopup.vue?vue&type=style&index=0&id=5a074a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a074a7c",
  null
  
)

export default component.exports